import debounce from 'lodash/debounce';

import '@splidejs/splide/css/core';
import '@neptune/cx/registry';

import './theme/tokens.scss';
import './theme/breakpoints.scss';
import './theme/global.scss';
import './theme/global-overrides.scss';
import './theme/typography.scss';
import './theme/utility.scss';

import './components/ay-card';
import './components/ay-chip';
import './components/ay-chip-list';

import './widget-templates/ay-category-list-facet';
import './widget-templates/ay-category-tree-facet';

import './fragments/banners/ay-hero-banner';
import './fragments/banners/ay-text-banner';

import './fragments/cards/ay-card-list';
import './fragments/cards/ay-large-info-card';
import './fragments/cards/ay-office-location-card-list';
import './fragments/cards/ay-property-listing-card-list';
import './fragments/cards/ay-property-listing-map-card-list';
import './fragments/cards/ay-person-card-list';
import './fragments/cards/ay-service-card-list';

import './fragments/content/ay-accordion';
import './fragments/content/ay-accordion-set';
import './fragments/content/ay-animated-counter';
import './fragments/content/ay-article-link-list';
import './fragments/content/ay-body-text';
import './fragments/content/ay-heading';
import './fragments/content/ay-pcr-recipient-helper';
import './fragments/content/ay-person-quote-block';
import './fragments/content/ay-primary-button';
import './fragments/content/ay-professional-profile';
import './fragments/content/ay-spacer';
import './fragments/content/ay-text-button';

import './fragments/layouts/ay-content-wrap';
import './fragments/layouts/ay-facet-accordion';
import './fragments/layouts/ay-search-layout';

import './fragments/util/ay-person-passthrough';
import './fragments/util/npt-collection-config';
import './fragments/util/npt-conditional-content';
import './fragments/util/npt-segmented-content';

import './page-editor/multi-select-reset';

import { DisposalSet, onReady, select } from '@neptune/cx/utils';

const gc = new DisposalSet();

onReady(() => {
    const styleRoot = select<HTMLElement>(':root');

    const measure = () => {
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        styleRoot.style.setProperty('--t-screen-width', `${width}px`);
        styleRoot.style.setProperty('--t-screen-height', `${height}px`);
    }

    const documentObserver = new ResizeObserver(measure);
    documentObserver.observe(document.documentElement);
    (gc.register(window)
        .addListener('resize', debounce(measure, 400))
    );
    gc.register(documentObserver.disconnect);
    measure();
    requestAnimationFrame(() => measure());
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
